import {createSlice } from '@reduxjs/toolkit'

const RevenueSlice = createSlice({
    name: "RevenueSlice",
    initialState: {
        TotalSum: false,
        FirstTotalSum: false,
        SecondTotalSum: false,
        AllMonthRavenue: [],
        RevenueArray: [],
        PercentCity: {
            Kashier: 0,
            Cook: 0,
            PrizeMinSum: 0,
            PrizeSumKashier: 0,
            PrizeSumCook: 0,
            RatioRevenue: 0,
            PrizeSumCookSecondGroup: 0,
        },
    },
    reducers: {
       setRevenueArray(state, actions){
        state.RevenueArray = actions.payload
        var FirstRes = 0
        var SecondRes = 0
        actions.payload.map((el) => {
            if(el.id < 15)
                {
                    FirstRes = FirstRes + parseFloat(el.Value)
                }
                else
                {
                    SecondRes = SecondRes + parseFloat(el.Value)
                }
                return(el)
        })
        state.SecondTotalSum = SecondRes.toFixed(2)
        state.FirstTotalSum = FirstRes.toFixed(2)
        state.TotalSum = actions.payload.reduce((Sum, el) => Sum + parseFloat(el.Value), 0).toFixed(2)
       },
       setAllMonthRavenue(state, actions){
        state.AllMonthRavenue = actions.payload
       },
       setPercentCity(state, actions){
            state.PercentCity.Kashier = actions.payload[0] || 0;
            state.PercentCity.Cook = actions.payload[1] || 0;
            state.PercentCity.PrizeMinSum = actions.payload[2] || 0;
            state.PercentCity.PrizeSumKashier = actions.payload[3] || 0;
            state.PercentCity.PrizeSumCook = actions.payload[4] || 0;
            state.PercentCity.RatioRevenue = actions.payload[5] || 0;
            state.PercentCity.CookSecondGroup = actions.payload[6] || 0;
            state.PercentCity.PrizeSumCookSecondGroup = actions.payload[7] || 0;            
       },
       cheangeValue(state, actions){
        state.RevenueArray.map((el) => {
            if(el.id === actions.payload.id)
                {
                    el.Value = actions.payload.Value
                }
            return(el)
        })
       },
       TotalSumFunction(state, actions){
        var FirstRes = 0
        var SecondRes = 0
        state.RevenueArray.map((el) => {
            if(el.id > (parseInt(actions.payload.MinDay) - 2) && el.id < actions.payload.MaxDay)
                {
                if(el.id < 15)
                {
                    FirstRes = FirstRes + parseFloat(el.Value)
                }
                else
                {
                    SecondRes = SecondRes + parseFloat(el.Value)
                }
            }
                return(el)
        })
            state.SecondTotalSum = SecondRes.toFixed(2)
            state.FirstTotalSum = FirstRes.toFixed(2)
            state.TotalSum = state.RevenueArray.reduce((Sum, el) => (el.id > (parseInt(actions.payload.MinDay) - 2) && el.id < actions.payload.MaxDay) ? Sum + parseFloat(el.Value) : Sum + 0, 0).toFixed(2)
       },
       ChangePercentCity(state, actions){
        switch(actions.payload.Type){
            case('Kashier'):{
                state.PercentCity.Kashier = actions.payload.Value
                break;
            }
            case('Cook'):{
                state.PercentCity.Cook = actions.payload.Value
                break;
            }
            case('CookSecondGroup'):{
                state.PercentCity.CookSecondGroup  = actions.payload.Value
                break;
            }
            case('PrizeMinSum'):{
                state.PercentCity.PrizeMinSum = actions.payload.Value
                break;
            }
            case('PrizeSumKashier'):{
                state.PercentCity.PrizeSumKashier = actions.payload.Value
                break;
            }
            case('PrizeSumCook'):{
                state.PercentCity.PrizeSumCook = actions.payload.Value
                break;
            }
            case('PrizeSumCookSecondGroup'):{
                state.PercentCity.PrizeSumCookSecondGroup = actions.payload.Value
                break;
            }
            case('RatioRevenue'):{
                state.PercentCity.RatioRevenue = actions.payload.Value
                break;
            }
            default:
                {
                    break;
                }
        }
       }
    }
})

export default RevenueSlice.reducer
export const {setRevenueArray, cheangeValue, TotalSumFunction, setPercentCity, ChangePercentCity, setAllMonthRavenue} = RevenueSlice.actions